"use strict";

var Timeline = function () {

  var set_email_contact_sender = function() {
    if ($('#timeline_notify_senders').is(':checked')) {
      $('#timeline_senders_list').show();
      
    } else {
      $('#timeline_senders_list').hide();
    }
  };

  var set_email_contact_consigne = function() {
    if ($('#timeline_notify_consignees').is(':checked')) {
      $('#timeline_consignes_list').show();
    } else {
      $('#timeline_consignes_list').hide();
    }
  };

  var set_email_contact_company = function() {
    if ($('#timeline_notify_companies').is(':checked')) {
      $('#timeline_companies_list').show();
    } else {
      $('#timeline_companies_list').hide();
    }
  };

  return {
    init: function () {
      $(document).on("change", "#timeline_notify_senders", function() {
        set_email_contact_sender();
      });
      set_email_contact_sender();
      
      $(document).on("change", "#timeline_notify_consignees", function() {
        set_email_contact_consigne();
      });
      set_email_contact_consigne();

      $(document).on("change", "#timeline_notify_companies", function() {
        set_email_contact_company();
      });
      set_email_contact_company();
    }
  };
}();

if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
  module.exports = Timeline;
}
